'use client';

// UIs
import { Badge, BadgeProps } from '@shared/ui';

// Utils
import { combineClasses } from '@shared/utils';
interface RoleBadgeProps extends BadgeProps {
  color?: string;
  hideLabel?: boolean;
}
const RoleBadge = ({
  label,
  color,
  hideLabel = false,
  className,
  ...props
}: RoleBadgeProps) => <Badge label={hideLabel ? '' : label} className={combineClasses('transition-all duration-300 ease-in-out px-3 py-1 cursor-pointer', hideLabel ? 'w-12.5 h-[10px]' : 'h-5 w-fit', 'rounded-sm text-white text-shadow-md hover:text-white',
// Add hover background using CSS variable
'hover:bg-[var(--hover-bg-color)]',
// Add default background using CSS variable
color && 'bg-[var(--bg-color)]', className)} style={{
  '--bg-color': color,
  '--hover-bg-color': color,
  backgroundColor: color
} as React.CSSProperties & Record<string, string>} {...props} {...hideLabel && {
  'data-hide-label': true
}} data-sentry-element="Badge" data-sentry-component="RoleBadge" data-sentry-source-file="index.tsx" />;
export default RoleBadge;